import React from "react";
import { Icon } from "antd";
import styles from "./header.scss";

const Header = ({ onClose }) => (
  <div className={styles.container}>
    <span className={styles.title}>{"Kontaktiraj oglašivača"}</span>
    <button type="button" onClick={onClose} className={styles.closeButton}>
      <Icon type="close" />
    </button>
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/EmailDealerModal/Header/index.tsx